import { ScriptLoader } from 'helpers/scriptLoader';
import { useEffect, useState } from 'react';
import { publicEnvConfig } from 'helpers/env';

const RecaptchaV2 = ({ onVerified, onExpired, onError, onLoaded, onRender }) => {
	const [loadedRecaptcha, setLoadedRecaptcha] = useState(false);
	const [loadedScript, setLoadedScript] = useState(false);
	const [rendered, setRendered] = useState(false);
	const RECAPTCHA_V2_SITE_KEY = publicEnvConfig.RECAPTCHA_V2_SITE_KEY;
	const SCRIPT_URL_V2 = 'https://www.google.com/recaptcha/api.js?onload=onloadCallbackRecaptcha&render=explicit';
	const id = 'recaptcha-script';

	const onLoadedScript = () => {
		setLoadedScript(true);
	};

	const onloadCallbackRecaptcha = () => {
		if (onLoaded) {
			onLoaded();
		}
		setLoadedRecaptcha(true);
	};

	if (process.browser) window.onloadCallbackRecaptcha = onloadCallbackRecaptcha;

	useEffect(() => {
		if (!rendered) {
			if (window.grecaptcha && window.grecaptcha.render) {
				const e = document.getElementById('recaptchaV2Container');
				if (e) e.innerHTML = '';
				window.grecaptcha.render('recaptchaV2Container', {
					sitekey: RECAPTCHA_V2_SITE_KEY,
					callback: onVerified,
					'expired-callback': onExpired,
					'error-callback': onError,
				});
				setRendered(true);
				if (onRender) onRender();
			}
		}
	}, [loadedRecaptcha, loadedScript, rendered, onVerified, onExpired, onError, onRender, RECAPTCHA_V2_SITE_KEY]);

	return (
		<>
			<div id="recaptchaV2Container"></div>
			<ScriptLoader id={id} url={SCRIPT_URL_V2} onLoadedScript={onLoadedScript} />
		</>
	);
};

export { RecaptchaV2 };
